import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined'
import i18n from 'core/common/i18n'
import { Button, Typography, IconButton } from 'core/components/Core'
import Modal from 'core/components/Modal'

function VariationSettingsDialog({ open, onClose, handleCopy, handleManual }) {
  return (
    <Modal
      title={
        <div className="d-flex justify-between">
          <Typography variant="h5">Novas variações</Typography>

          <IconButton
            size="small"
            onClick={onClose}
            aria-label={i18n.t('productNew.basicData.closeButtonAriaLabel')}
          >
            <CloseOutlinedIcon />
          </IconButton>
        </div>
      }
      open={open}
      onCancel={onClose}
      maxWidth="sm"
    >
      <Typography variant="body1">
        Parece que você criou nova(s) variação(ões) do produto. Agora, é hora de definir alguns
        detalhes importantes para elas. Você pode optar por definir as dimensões, preço e estoque
        por canal manualmente. Ou, se preferir, pode simplesmente copiar automaticamente para elas
        os valores das demais variações j á publicadas nesse produto.
      </Typography>

      <div className="mt-4 d-flex justify-center">
        <Button variant="text" color="primary" onClick={handleManual} className="flex-1">
          <span>Definir manualmente</span>
        </Button>

        <Button variant="contained" color="primary" onClick={handleCopy} className="flex-1">
          <span>Copiar valores</span>
        </Button>
      </div>
    </Modal>
  )
}

export default VariationSettingsDialog
